import { Component, OnInit, Input, APP_INITIALIZER, ViewChild, ElementRef } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { SharedService } from 'src/app/services/SharedService';
import { CapacityByPlant } from '../types/CapacityByPlant';
import { DemandCapacity } from '../types/DemandCapacity';
import { ExclusiveCapacityByPlant } from '../types/ExclusiveCapacityByPlant';
import { DxDataGridComponent } from 'devextreme-angular';
import { LocationSnapshotFilters } from '../types/LocationSnapshotFilters';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

@Component({
  selector: 'demand-capacity',
  templateUrl: './demand-capacity.component.html'
})
export class DemandCapacityComponent implements OnInit {
  @ViewChild('demandCapacitySnapshotGrid', { static: true }) demandCapacitySnapshotGrid: DxDataGridComponent;
  @ViewChild('demandCapacitySnapshotNonAPGrid', { static: true }) demandCapacitySnapshotNonAPGrid: DxDataGridComponent;
  @ViewChild('demandCapacitySnapshotByCountryGrid', { static: true }) demandCapacitySnapshotByCountryGrid: DxDataGridComponent;
  @ViewChild('demandCapacityByPlantGrid', { static: true }) demandCapacityByPlantGrid: DxDataGridComponent;
  @ViewChild('demandCapacityByPlantExclusiveGrid', { static: true }) demandCapacityByPlantExclusiveGrid: DxDataGridComponent;

  _demandCapacities: DemandCapacity[];
  _capacityByPlants: CapacityByPlant[];
  _exclusiveCapacityByPlants: ExclusiveCapacityByPlant[];
  _filters: LocationSnapshotFilters = {
    countryIDs: [],
    siteIDs: [],
    globalIndustrySegmentIDs: [],
    radiusAroundEachPlant: 200,
    includeSuspectList: false,
    removeExcluded: false,
    crossCountryBorders: false,
    limitToSiteRevenueGrtThan1MM: false,
    showDistanceRings: false,
    includeSAPCustomerList: false,
    plantCompany: '',
    trailerSize: 0,
    distributionCost: 0,
    siteNames: '',
    globalSegments: '',
    product: ['LOX/LIN']
  };
  @Input()

  set demandCapacities(value: DemandCapacity[]) {

    this._demandCapacities = value;
  }

  get demandCapacities(): DemandCapacity[] {
    return this._demandCapacities;
  }

  @Input()

  set capacityByPlants(value: CapacityByPlant[]) {

    this._capacityByPlants = value;
  }

  get capacityByPlants(): CapacityByPlant[] {
    return this._capacityByPlants;
  }

  @Input()

  set exclusiveCapacityByPlants(value: ExclusiveCapacityByPlant[]) {

    this._exclusiveCapacityByPlants = value;
  }

  get exclusiveCapacityByPlants(): ExclusiveCapacityByPlant[] {
    return this._exclusiveCapacityByPlants;
  }

  @Input()

  set filters(value: LocationSnapshotFilters) {

    this._filters = value;
    this.header6 = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s) below:`;
    this.header7 = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s), subtotaled by customer\'s country :`;
    this.header8 = `Existing ASU Capacity within ${this.filters.radiusAroundEachPlant} miles:`;
    this.header12 = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s), predicted volumes exclude AP accounts below:`;
  }

  get filters(): LocationSnapshotFilters {
    return this._filters;
  }

  today = new Date();
  chooserMode: string = 'select';
  userName = this.sharedSvc.UserRoles.userName;
  demandCapacityDataSource: any;
  header1: string = 'Location Snapshot Analysis by Plant';
  header2: string = 'AIR PRODUCTS CONFIDENTIAL - INTERNAL USE ONLY';
  header3: string = `Report run by ${this.userName} on ${this.today}`;
  header4: string = 'If you export this report to Excel, be sure to look at all the worksheets in the workbook. Any volumes listed per plant cannot be added with the volume of a nearby plant, because potential customers \
  will be double-counted.';
  header5: string = ' To get demand when plants are close to each other, run the Volume for Two (or Three) \
  Overlapping Plant Areas report from the full portal page. Winnable totals come from historical lead generation results from 2010-2011 in N. America;'
  header6: string = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s) below:`;
  header7: string = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s), subtotaled by customer\'s country :`;
  header8: string = `Existing ASU Capacity within ${this.filters.radiusAroundEachPlant} miles:`;
  header9: string = '* Nameplate Capacity is the total plant capacity listed in the database. The Relevant Capacity is a fraction of nameplate';
  header10: string = 'This table shows the capacity in the combined area of the chosen plants:';
  header11: string = 'This table shows the capacity around each of the chosen plants:';
  header12: string = `Estimated Demand within ${this.filters.radiusAroundEachPlant} miles of Air Products plant(s), predicted volumes exclude AP accounts below:`;
  constructor(private notificationService: NotificationService,
    private route: ActivatedRoute, private router: Router, private sharedSvc: SharedService) {
    this.demandCapacityDataSource = {
      fields: [{
        caption: 'Plant Sitename',
        width: 120,
        dataField: 'plantSiteName',
        area: 'row',
      }, {
        dataField: 'mtDgrossN2',
        area: 'column',
      },
      {
        groupName: 'mtDgrossN2',
        visible: false,
      },
      {
        caption: 'N2',
        dataField: 'mtDgrossN2',
        dataType: 'number',
        area: 'data',
      }],
      store: this.demandCapacities,
    };

  }

  getExcelFileName(): string {
    let date = new Date();
    let currentMonth = ("0" + (date.getMonth() + 1)).slice(-2);
    let dateTime = date.getFullYear() + "" + currentMonth + "" + date.getDate() + "" + date.getHours() + "" + date.getMinutes();
    let fileName = "LocationSnapshot_" + dateTime;
    return fileName;
  }


  exportExcel_Snapshot(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('DemandCapacitySnapshot');
    exportDataGrid({
      component: this.demandCapacitySnapshotGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          this.convertStringToNumber(excelCell, 1);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacitySnapshot.xlsx');
        });
    });
    e.cancel = true;
  }


  exportExcel_SnapshotNonAP(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('DemandCapacitySnapshotNonAp');
    exportDataGrid({
      component: this.demandCapacitySnapshotNonAPGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          this.convertStringToNumber(excelCell, 1);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacitySnapshotNonAp.xlsx');
        });
    });
    e.cancel = true;
  }


  exportExcel_SnapshotByCountry(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('DemandCapacitySnapshotByCountry');
    exportDataGrid({
      component: this.demandCapacitySnapshotByCountryGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          this.convertStringToNumber(excelCell, 1);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacitySnapshotByCountry.xlsx');
        });
    });
    e.cancel = true;
  }

  exportExcel_SnapshotByPlant(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('DemandCapacitySnapshotByPlant');
    exportDataGrid({
      component: this.demandCapacityByPlantGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          this.convertStringToNumber(excelCell, 1);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacitySnapshotByPlant.xlsx');
        });
    });
    e.cancel = true;
  }


  exportExcel_SnapshotByPlantExclusive(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('DemandCapacitySnapshotByPlantExclusive');
    exportDataGrid({
      component: this.demandCapacityByPlantExclusiveGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          this.convertStringToNumber(excelCell, 1);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacitySnapshotByPlantExclusive.xlsx');
        });
    });
    e.cancel = true;
  }

  exportGrids(e) {

    const workbook = new Workbook();

    const context = this;

    const demandCapacitySheet = workbook.addWorksheet('Demand Capacity');
    this.setDemandCapacityHeaders(demandCapacitySheet)

    exportDataGrid({
      worksheet: demandCapacitySheet,
      component: this.demandCapacitySnapshotGrid.instance,
      topLeftCell: { row: 9, column: 2 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
          this.convertStringToNumber(excelCell);
        }

        if (gridCell.rowType === 'totalFooter' && excelCell.value) {
          excelCell.font.italic = true;
        }
        if (gridCell.data === 'Global Industry Segment') {
          excelCell.fill = { fgColor: { argb: '00a8e1' }, bgColor: { argb: 'BEDFE6' } };
        }
      },
    }).then((cellRange) => {
      let headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 2);

      headerRow.getCell(2).value = this.header12;
      headerRow.getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
      headerRow.getCell(2).font = { size: 12, color: { argb: 'FF0000' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
    }).then(() => exportDataGrid({
      worksheet: demandCapacitySheet,
      component: this.demandCapacitySnapshotNonAPGrid.instance,
      topLeftCell: { row: demandCapacitySheet.rowCount - 2, column: 2 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
          this.convertStringToNumber(excelCell);
        }

        if (gridCell.rowType === 'totalFooter' && excelCell.value) {
          excelCell.font.italic = true;
        }
      },
    })).then((cellRange) => {
      let headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 3);

      headerRow.getCell(2).value = this.header7;
      headerRow.getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
    }).then(() => exportDataGrid({
      worksheet: demandCapacitySheet,
      component: this.demandCapacitySnapshotByCountryGrid.instance,
      topLeftCell: { row: demandCapacitySheet.rowCount - 2, column: 2 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
          this.convertStringToNumber(excelCell);
        }

        if (gridCell.rowType === 'totalFooter' && excelCell.value) {
          excelCell.font.italic = true;
        }
      },
    })).then((cellRange) => {
      // header
      let headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 3);

      headerRow.getCell(2).value = this.header8;
      headerRow.getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);

      headerRow.getCell(2).value = this.header9;
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 2);

      headerRow.getCell(2).value = this.header10;
      headerRow.getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
    }).then(() => exportDataGrid({
      worksheet: demandCapacitySheet,
      component: this.demandCapacityByPlantGrid.instance,
      topLeftCell: { row: demandCapacitySheet.rowCount, column: 2 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === 'group') {
          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
          this.convertStringToNumber(excelCell);
        }

        if (gridCell.rowType === 'totalFooter' && excelCell.value) {
          excelCell.font.italic = true;
        }
      },
    })).then((cellRange) => {
      let headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 3);

      headerRow.getCell(2).value = this.header11;
      headerRow.getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
      headerRow = demandCapacitySheet.getRow(demandCapacitySheet.rowCount + 1);
      headerRow.font = { size: 12, color: { argb: '00a8e1' } };
    })
      .then(() => exportDataGrid({
        worksheet: demandCapacitySheet,
        component: this.demandCapacityByPlantExclusiveGrid.instance,
        topLeftCell: { row: demandCapacitySheet.rowCount, column: 2 },
        customizeCell: ({ gridCell, excelCell }) => {
          if (gridCell.rowType === 'group') {
            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
            this.convertStringToNumber(excelCell);
          }

          if (gridCell.rowType === 'totalFooter' && excelCell.value) {
            excelCell.font.italic = true;
          }
        },
      }))
      .then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DemandCapacities.xlsx');
        });

      });

  }

  private setDemandCapacityHeaders(demandCapacitySheet) {

    demandCapacitySheet.getRow(2).getCell(2).value = this.header1;
    demandCapacitySheet.getRow(2).getCell(2).font = { bold: true, size: 16, underline: 'double', color: { argb: '009a49' } };

    demandCapacitySheet.getRow(3).getCell(2).value = this.header2;
    demandCapacitySheet.getRow(3).getCell(2).font = { color: { argb: 'FF0000' } };

    demandCapacitySheet.getRow(4).getCell(2).value = this.header3;

    demandCapacitySheet.getRow(5).getCell(2).value = this.header4;

    demandCapacitySheet.getRow(6).getCell(2).value = this.header5;

    demandCapacitySheet.getRow(8).getCell(2).value = this.header6;
    demandCapacitySheet.getRow(8).getCell(2).font = { bold: true, size: 14, color: { argb: '009a49' } };
    demandCapacitySheet.getRow(9).font = { size: 12, color: { argb: '00a8e1' } };
    demandCapacitySheet.getRow(10).font = { size: 12, color: { argb: '00a8e1' } };
    demandCapacitySheet.getRow(11).font = { size: 12, color: { argb: '00a8e1' } };
  }


  ngOnInit(): void {

  }

  convertStringToNumber(excelCell, colNumber: number = 2) {
    if (!excelCell.value) return;
    if (excelCell._column.number > colNumber) {
      if (!isNaN(excelCell.value.replace(/,/g, ''))) {
        excelCell.value = parseFloat(excelCell.value.replace(/,/g, ''));
        excelCell.numFmt = '#,##0.0';
      }
    }
  }

}
